import { customerFunctions } from 'packs/customers/functions'
import initTooltips from 'src/tooltips'

export default () => {
  customerFunctions()

  $('#myyja-notes-datatable').DataTable({
    language: {
      url: '/datatable_i18n'
    },
    processing: true,
    serverSide: true,
    ajax: {
      url: $('#myyja-notes-datatable').data('source')
    },
    order: [[9, 'asc']],
    columns: [
      { data: 'company_name' },
      { data: 'location_name' },
      { data: 'business_id' },
      { data: 'industry' },
      { data: 'address' },
      { data: 'contact_person' },
      { data: 'phone' },
      { data: 'email' },
      {
        data: 'notes',
        className: 'notes-col',
        createdCell: function(td, cellData, rowData) {
          if (rowData.notes_full) {
            td.setAttribute('data-bs-toggle', 'tooltip')
            td.setAttribute('data-bs-placement', 'left')
            td.setAttribute('data-bs-custom-class', 'notes-tooltip')
            td.setAttribute('title', rowData.notes_full)
          }
        }
      },
      { data: 'follow_up_date' }
    ],
    drawCallback: function() {
      // T-98: the dispose-then-create loop this file already had correctly is now shared —
      // `src/tooltips.js`. The QC pack's copy was the one that leaked.
      initTooltips(document.querySelector('#myyja-notes-datatable'))
    }
  })
}
